import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {OrdersService} from "@app/features/orders/orders.service";
import {NgxSpinnerService} from "ngx-spinner";

@Component({
  selector: 'app-orders-details',
  templateUrl: './orders-details.component.html',
  styleUrls: ['./orders-details.component.scss']
})
export class OrdersDetailsComponent implements OnInit {
  public order: any;
  storeQrcode: any;

  constructor(public route: ActivatedRoute,
              public spinner: NgxSpinnerService,
              public orderService: OrdersService) {
  }

  ngOnInit() {
    this.spinner.show().then(r => {
    });

    this.initOrderDetails(this.route.snapshot.params['id']);
  }

  public initOrderDetails(id: any) {
    this.orderService.getOrderDetails(id).subscribe(res => {
        this.order = res;
        this.storeQrcode = JSON.stringify({code: this.order.code});
        this.spinner.hide();
      },
      error => {
        this.spinner.hide();
        console.log(error);
      });
  }
}
